<template>
    <vs-input
      v-model="DisplayLabel"
      @blur="setVal"
    />
</template>

<script>
export default {
  name: 'CellDisplayLabel',
  data() {
    return {
      DisplayLabel: null,
    }
  },
  created(){
    this.DisplayLabel  = this.params.value
  },
  methods:{
    setVal(){
      this.params.setValue(this.DisplayLabel)
    }
  },
}
</script>